import DocumentImporterConfiguration from "../payslips/services/model/DocumentImporterConfiguration";
import {
  SupportedDocumentAttributes,
  SupportedFeatures,
} from "../payslips/services/model/FeatureConfiguration";

export const RosterJourneyConfiguration: DocumentImporterConfiguration = {
  document_type: SupportedFeatures.ROSTERS,
  document_name: "Roster",
  document_name_lower_case: "roster",
  document_name_plural: "Rosters",
  document_name_plural_lower_case: "rosters",
  main_page_route: "",
  attributes: [
    SupportedDocumentAttributes.START_AND_END_PERIOD,
    SupportedDocumentAttributes.DISTRIBUTION_DATES,
    SupportedDocumentAttributes.BATCH_NAME,
  ],
};
